import { render, staticRenderFns } from "./RoomActions.vue?vue&type=template&id=0b959470&scoped=true&"
import script from "./RoomActions.vue?vue&type=script&lang=ts&"
export * from "./RoomActions.vue?vue&type=script&lang=ts&"
import style0 from "./RoomActions.vue?vue&type=style&index=0&id=0b959470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b959470",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b959470')) {
      api.createRecord('0b959470', component.options)
    } else {
      api.reload('0b959470', component.options)
    }
    module.hot.accept("./RoomActions.vue?vue&type=template&id=0b959470&scoped=true&", function () {
      api.rerender('0b959470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/rooms/room/RoomActions.vue"
export default component.exports